import useUser from 'store/user/useUser';
import Form from 'components/Form';
import RowContainer from '../Main/Survey/components/RowContainer';

import {
  Typography,
  Stack,
  useTheme,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Box,
} from '@mui/material';
import { ReactComponent as PlayBtn } from '../../assets/playBtn.svg';

interface Props {
  disabled?: boolean;
}

const StudentModeInfoExemple = (props: Props) => {
  const { palette } = useTheme();

  function createData(id: number, title: string, link: string) {
    return { id, title, link };
  }

  const rows = [
    createData(1, '활력징후', 'https://youtu.be/uUw7m9Uivtc'),
    createData(2, '통증관리', 'https://youtu.be/CjU-XuRkZug'),
    createData(3, '욕창관리 및 낙상예방간호', 'https://youtu.be/2AtUTBWPmNY'),
    createData(4, '경구투약', 'https://youtu.be/in7pLitqg1M'),
    createData(5, '근육주사', 'https://youtu.be/P_1ZenFowgM'),
    createData(6, '피하주사', 'https://youtu.be/JtzygciLTmI'),
    createData(7, '피내주사', 'https://youtu.be/ODMDb5R5e3A'),
    createData(8, '정맥주사', 'https://youtu.be/8IWFJdDjmV0'),
    createData(9, '수혈요법', 'https://youtu.be/-AYs-XfvBUg'),
    createData(10, '간헐적 위관영양', 'https://youtu.be/UF-2L7VWzT8'),
    createData(11, '단순도뇨', 'https://www.youtube.com/watch?v=aDw6Z__O_dk'),
    createData(12, '유치도뇨', 'https://youtu.be/-PVSLAux6JY'),
    createData(13, '배출관장', 'https://youtu.be/OlYkESlB3hs'),
    createData(14, '배액관관리', 'https://youtu.be/SfyBHbkxGMk'),
    createData(15, '모니터링', 'https://youtu.be/_1ZiXeoOlJ8'),
    createData(16, '산소요법', 'https://youtu.be/7X5gShJ-wyo'),
    createData(17, '흡인', 'https://youtu.be/VsjUlN5H9Vw'),
    createData(18, '심폐소생술', 'https://youtu.be/ccLBgA_dwPE'),
  ];

  return (
    <TableContainer>
      <Table>
        <TableCell>
          <Typography
            color={palette.mode === 'dark' ? 'black' : palette.text.primary}
            fontSize={15}
            fontWeight="bold"
            sx={{
              width: 120,
              p: 1,
              backgroundColor:
                palette.mode === 'dark' ? 'lightgrey' : '#EDF3FA',
              textAlign: 'center',
            }}
          >
            영상 번호
          </Typography>
        </TableCell>
        <TableCell sx={{ display: 'flex', justifyContent: 'center' }}>
          <Typography
            color={palette.mode === 'dark' ? 'black' : palette.text.primary}
            fontSize={15}
            fontWeight="bold"
            sx={{
              width: 600,
              p: 1,
              backgroundColor:
                palette.mode === 'dark' ? 'lightgrey' : '#EDF3FA',
              textAlign: 'center',
            }}
          >
            영상 제목
          </Typography>
        </TableCell>
        <TableCell>
          <Typography
            color={palette.mode === 'dark' ? 'black' : palette.text.primary}
            fontSize={15}
            fontWeight="bold"
            sx={{
              width: 120,
              p: 1,
              backgroundColor:
                palette.mode === 'dark' ? 'lightgrey' : '#EDF3FA',
              textAlign: 'center',
            }}
          >
            바로보기
          </Typography>
        </TableCell>
        <TableBody>
          {rows.map(row => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell
                sx={{ paddingLeft: '4.2rem', fontWeight: 'bold', fontSize: 16 }}
              >
                {row.id}
              </TableCell>
              <TableCell sx={{ paddingLeft: '9rem', fontSize: 16 }}>
                {row.title}
              </TableCell>
              <TableCell sx={{ paddingLeft: '4.2rem' }}>
                <PlayBtn
                  onClick={() => window.open(`${row.link}`, '_blank')}
                  cursor="pointer"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-end'}
        sx={{ marginTop: '20px', width: '100%' }}
      >
        <Typography sx={{ fontSize: '12px', color: `${palette.primary.main}` }}>
          해당 예시 영상은 대한나래출판사에서 제작되었습니다.
          <br />
          또한 교재 ‘슬기로운 임상간호술기’의 영상 입니다.
        </Typography>
      </Box>
    </TableContainer>
  );
};

export default StudentModeInfoExemple;
